/* ========== BOX & WHISKER CHART ========== */

import { COLORS, drawAxes, drawGridlines } from './utils';

export function drawBoxWhiskerChart(ctx, x, y, width, height, chartObj) {
  var seriesArr = chartObj && chartObj.series ? chartObj.series : [];
  if (seriesArr.length === 0) return;
  var cats = chartObj.categories || [];

  // chartEx Box & Whisker delivers ONE series of raw values with a
  // category label per point ("A","A","A","B","B",…). One box must be
  // drawn per distinct category — not one box for the whole series.
  if (seriesArr.length === 1 && cats.length >= seriesArr[0].data.length && seriesArr[0].data.length > 0) {
    var groupsMap = {};
    var groupOrder = [];
    seriesArr[0].data.forEach(function (v, i) {
      var key = cats[i] || '';
      if (!groupsMap[key]) { groupsMap[key] = []; groupOrder.push(key); }
      groupsMap[key].push(v);
    });
    if (groupOrder.length > 1) {
      var color = seriesArr[0].color;
      seriesArr = groupOrder.map(function (key) {
        return { name: key, data: groupsMap[key], color: color };
      });
      cats = groupOrder;
    }
  }

  var allVals = seriesArr.flatMap(function (s) { return s.data; });
  var minValue = Math.min.apply(null, allVals.concat([0]));
  var maxValue = Math.max.apply(null, allVals.concat([0]));
  var range = maxValue - minValue || 100;

  drawGridlines(ctx, x, y, width, height, minValue, range);

  var numGroups = seriesArr.length;
  var groupWidth = width / Math.max(numGroups, 1);

  function toY(val) {
    return y + height - ((val - minValue) / range) * height;
  }

  seriesArr.forEach(function (series, sIdx) {
    var data = series.data.slice().sort(function (a, b) { return a - b; });
    if (data.length === 0) return;

    var q1 = data[Math.floor(data.length * 0.25)];
    var median = data[Math.floor(data.length * 0.5)];
    var q3 = data[Math.floor(data.length * 0.75)];
    var whiskerLow = data[0];
    var whiskerHigh = data[data.length - 1];
    var color = series.color || COLORS[sIdx % COLORS.length];

    var cx = x + sIdx * groupWidth + groupWidth / 2;
    var boxW = groupWidth * 0.5;

    // Whisker line
    ctx.strokeStyle = '#555';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(cx, toY(whiskerHigh));
    ctx.lineTo(cx, toY(whiskerLow));
    ctx.stroke();

    // Whisker caps
    ctx.beginPath();
    ctx.moveTo(cx - boxW * 0.3, toY(whiskerHigh));
    ctx.lineTo(cx + boxW * 0.3, toY(whiskerHigh));
    ctx.moveTo(cx - boxW * 0.3, toY(whiskerLow));
    ctx.lineTo(cx + boxW * 0.3, toY(whiskerLow));
    ctx.stroke();

    // Box (Q1 to Q3)
    var boxTop = toY(q3);
    var boxBottom = toY(q1);
    ctx.fillStyle = color;
    ctx.globalAlpha = 0.5;
    ctx.fillRect(cx - boxW / 2, boxTop, boxW, boxBottom - boxTop);
    ctx.globalAlpha = 1;
    ctx.strokeStyle = color;
    ctx.lineWidth = 1.5;
    ctx.strokeRect(cx - boxW / 2, boxTop, boxW, boxBottom - boxTop);

    // Median line
    ctx.strokeStyle = '#333';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(cx - boxW / 2, toY(median));
    ctx.lineTo(cx + boxW / 2, toY(median));
    ctx.stroke();

    // Category label
    ctx.fillStyle = '#666';
    ctx.font = '9px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.fillText(cats[sIdx] || series.name || ('' + (sIdx + 1)), cx, y + height + 6);
  });

  drawAxes(ctx, x, y, width, height);
}
